/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { useState } from 'react';
//import Header from './Header';
import FAQ from './FAQ';
import { IObrienFaqViewProps } from './obrien-faq';

export default (props: IObrienFaqViewProps) => {
    const [faqs, setfaqs] = useState([
        {
            question: 'I bought something from your store, when should I expect to receive my products?',
            answer: 'Processing and shipping typically takes 3-5 business days. See the map below for the estimated shipping duration.',
            open: false,
            size: 'faq-answer medium'
        },
        {
            question: 'How long is the O\'Brien warranty?',
            answer: 'O\'Brien offers a one year warranty on all products except for non-towables, they have a 90 day warranty.',
            open: false,
            size: 'faq-answer small'
        },
        {
            question: 'Help! I am having an issue with my O\'Brien product and would like to inquire about a warranty, where should I start?',
            answer: 'First, bring your proof of purchase and product back to the authorized O\'Brien dealer in which it was purchased from. All O\'Brien dealers honor our one year warranty. If for some reason you are unable to obtain a replacement through your O\'Brien dealer, please click on "warranty" under the contact tab and fill out and send to us the required information listed. We will reply to you ASAP, typically within 24 hours. If you are still having issues with finding a replacement, please  contact O\'Brien customer service at 1 (800) 662-7436.',
            open: false,
            size: 'faq-answer large'
        },
        {
            question: 'Does O\'Brien sell replacement covers for their towable?',
            answer: 'No. Unfortunately, due to costing, we are unable to manufacture covers separately for our inflatables.',
            open: false,
            size: 'faq-answer small'
        },
        {
            question: 'Oh no! I have lost the plug (Boston Valve) to my inflatable, how can I obtain a new one?',
            answer: ['We have them in stock ', <a href="https://obrien.com">here!</a>, ' If you are in a pinch and need one expedited, you can purchase replacement Boston Valves using expedited shipping through online dealers or consulting a local dealer in your area. For standard delivery, please contact O’Brien customer service at 1 (800) 662-7436. For a picture of a Boston Valve, please look under the accessories tab.'],
            open: false,
            size: 'faq-answer large'
        },
        {
            question: 'My O’Brien inflatable won’t hold air, what can I do?',
            answer: 'First, check your Boston Valve and ensure it is fastened securely, so that no air is able to escape. For instructions on proper inflation, please click on the following link for an instructional video. If you find that your leak is coming from a puncture or hole in the tube, follow the instruction on your O’Brien repair patch that came with your inflatable. If your leak is on a seam or you are unable to repair it, please contact O’Brien customer service if you would like to purchase a replacement .Please note, we only carry a select few replacement parts for tubes, and your tube may not be sold separately.',
            open: false,
            size: 'faq-answer large'
        },
        {
            question: 'What is the best way to inflate my O’Brien tube?',
            answer: [<a href="https://obrien.com">Check out this video!</a>, ' The most common issues with inflatables are due to the fact that they are under inflated. Always be sure you inflate your tube properly.'],
            open: false,
            size: 'faq-answer medium'
        },
        {
            question: 'Wow, that Wakeboard looks awesome! I want to buy it. Where can I buy it?',
            answer: 'You can only purchase product through an authorized O’Brien dealer, and our website. To find a dealer in your area, please click on the O’Brien dealer locator. From there, you will be able to use your address to find local dealers. If you would like to purchase product online, websites are listed in the dealer locator as well. O’Brien is a wholesale company and unable to sell directly to the public.',
            open: false,
            size: 'faq-answer large'
        },
        {
            question: 'I have been an O’Brien customer for years and have an older board or ski. Can I get replacement parts for my old skis, boards, or bindings?',
            answer: 'Unfortunately we do not sell replacement parts or bindings for older (10 years or so) skis and wakeboards. For older ski bindings, please contact Wiley’s at (206) 762-1300.',
            open: false,
            size: 'faq-answer medium'
        },
        {
            question: 'I have an old O’Brien ski or wakeboard. How much is it worth?',
            answer: 'Unfortunately we are unable to assess market value for used product. Our best suggestion is to research popular sites such as EBAY or Craigslist for the going rate on similar or same product.',
            open: false,
            size: 'faq-answer medium'
        }
    ]);

    // @ts-ignore
    const toggleFAQ = index => {
        setfaqs(faqs.map((faq, i) => {
            if (i === index) {
                faq.open = !faq.open
            } else {
                faq.open = false;
            }
            return faq;
        }))
    }

    return (
        <div className='faq-module inside-md'>
            <div className="faqs">
                {faqs.map((faq, i) => (

                    <FAQ faq={faq} index={i} toggleFAQ={toggleFAQ} />

                ))}
            </div>
        </div>
    );
};
